import api from './api'

export default {
  getAll(params = {}) {
    return api.get('/admin/resources', { params })
  },

  getOne(id) {
    return api.get(`/admin/resources/${id}`)
  },

  create(payload) {
    return api.post('/admin/resources', payload)
  },

  update(id, payload) {
    return api.put(`/admin/resources/${id}`, payload)
  },

  publish(id) {
    return api.post(`/admin/resources/${id}/publish`)
  },

  archive(id) {
    return api.post(`/admin/resources/${id}/archive`)
  },

  // Soumissions company
  getSubmissions(params = {}) {
    return api.get('/admin/resources/submissions', { params })
  },

  approve(id, payload = {}) {
    return api.post(`/admin/resources/${id}/approve`, payload)
  },

  reject(id, payload = {}) {
    return api.post(`/admin/resources/${id}/reject`, payload)
  },

  // Localisation (US BO tranche 2) — créer en 1 langue, générer les autres via le
  // moteur, puis éditer chaque langue.
  getTranslations(id) {
    return api.get(`/admin/resources/${id}/translations`)
  },

  localize(id, locales = null) {
    return api.post(`/admin/resources/${id}/localize`, locales ? { locales } : {})
  },

  saveTranslation(id, locale, payload) {
    return api.put(`/admin/resources/${id}/translations/${locale}`, payload)
  },
}
